"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.debounceAdv = debounceAdv;
function debounceAdv(fn, delay = 100) {
    let timeoutId = null;
    return function (...args) {
        if (!timeoutId) {
            fn.apply(this, args);
        }
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
            clearTimeout(timeoutId);
            timeoutId = null;
        }, delay);
    };
}
